import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../services/api.service';
import { LocalStorageService } from '../services/localstorage.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: [],
  providers: [ApiService]
})
export class HomeComponent implements OnInit {

  spaces = [];
  searchInput = '';

  constructor(
    private _api: ApiService,
    private _router: Router,
    private _storage: LocalStorageService
  ) { }

  ngOnInit() {
    this.getSpaces()
  }

  filterSpaces(t, filter) {
    if (filter) {
      return t.name.toUpperCase().indexOf(filter.toUpperCase()) > -1
    } else {
      return true
    }
  }

  getSpaces () {
    this._api.spaces
      .list()
      .subscribe(
        (data) => {
          this.spaces = data.results;
        },
        (errors) => {
        }
      )

  }

  logout(): void {
    this._storage.clear();
    this._router.navigate(['']);
  }

}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts